import { createAction } from '@reduxjs/toolkit';
import * as types from './type';
import axiosAdapter from '../../../../utils/Adapters';
import { CMSAPI_INDEX } from '../../../../utils/CmsAPI';
import config from '../../../../config';

const requestFetch = createAction(types.ACTION_REQUEST);
const receiveSuccess = createAction(types.ACTION_SUCCESS);
const receiveError = createAction(types.ACTION_ERROR);

const massageData = (response) => {
  return response.data.result.assets.map((v) => {
    const { content, metadata, ...rest } = v;
    return {
      ...rest,
      topMetadata: metadata,
      ...v.content.content,
    };
  });
};

const messageError = (error) => {
  const message =
    ((((error || {}).response || {}).data || {}).error || {}).message || error.message;
  return message;
};

const fetchData = (category_id) => {
  const queryParameters = {
    sortBy: 'dcrCreatedDate',
    prefixPath: config.lscsPath,
    q: `((TeamSite/Templating/DCR/Type:${config.pageType.videoDetailPage}) AND (displayStatus:true) AND (videoCategory:${category_id}))`,
    start: 0,
    max: 6,
    projectName: config.cmsProjectName,
    enableDate: false,
  };
  const url = CMSAPI_INDEX(queryParameters);
  return axiosAdapter({
    url,
  });
};

const getVideoDetail = (category_id) => {
  return (dispatch) => {
    dispatch(requestFetch());
    return fetchData(category_id)
      .then((response) => massageData(response))
      .then((data) => {
        dispatch(receiveSuccess(data));
      })
      .catch((error) => {
        const message = messageError(error);
        dispatch(receiveError(message));
      });
  };
};

export { getVideoDetail };
